import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { InvestmentsPeriodEventType } from '../investments-period.event.type';
import { InvestmentsService } from '../../investments.service';
import { Investment } from '../../investments-extract/models/investment';
import { EventTypes } from '../../../../shared/EventTypes';
import { TweenMax } from 'gsap';

@Component({
	selector: 'app-period-cards',
	templateUrl: './period-cards.component.html',
	styleUrls: ['./period-cards.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PeriodCardsComponent implements OnInit, OnDestroy {

	private dateBegin: any = new Date();
	private dateEnd: any = new Date();

	investments: Array<Investment> = [];
	isLoading: boolean;
	@Input() submited: boolean;

	constructor(private investmentsService: InvestmentsService) { }

	ngOnInit() {
		AppEventDispatcher.listen(InvestmentsPeriodEventType.UPDATE, data => {
			this.dateBegin = data.dateBegin;
			this.dateEnd = data.dateEnd;

			this.preload(true);
			this.isLoading = true;

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.investmentsService.getMyInvestments(this.dateBegin, this.dateEnd).subscribe( dataInvestments => {


				this.investments = dataInvestments;
				if (!dataInvestments.length) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Não há investimentos para este período.' });
				}

				this.submited = true;

				if (time > 3) {
					this.preload(false);
					this.isLoading = false;
				}	else {
					TweenMax.delayedCall(3 - time, () => {
						this.preload(false, 3 - time);
						this.isLoading = false;
					});
				}
				clearInterval(timeLoader);
			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(InvestmentsPeriodEventType.UPDATE);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="investments-period"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-period/period-cards/period-cards.component.ts